import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sex'
})
export class SexPipe implements PipeTransform {

  transform(str: string): unknown {
    switch (str) {
      case 'M':
        return '男';
      case 'F':
        return '女';
      default:
        return '';
    }
  }

}
